import { render, staticRenderFns } from "./addBid1.vue?vue&type=template&id=74c4ae26&scoped=true"
import script from "./addBid1.vue?vue&type=script&lang=js"
export * from "./addBid1.vue?vue&type=script&lang=js"
import style0 from "./addBid1.vue?vue&type=style&index=0&id=74c4ae26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c4ae26",
  null
  
)

export default component.exports